module.exports = __webpack_public_path__ + "static/media/loadstart.44947b84.png";